import { withRouter } from "react-router-dom";
import YouHaveJoinedPage from "./YouHaveJoinedPage";

export default withRouter(YouHaveJoinedPage);
